import React from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "app/components/ui/button";

const platformDrivers = [
  {
    icon: "/assets/coverage.svg",
    altText: "Coverage",
    title: "Triple Network Coverage",
    description: `Never miss a ride or delivery opportunity due to poor service. With VLE Mobile's triple network access, your phone automatically switches between all three major US networks for the best possible coverage. <br /> <br /> <span style="font-weight: 600;">No more dead zones = More earnings</span>`,
  },
  {
    icon: "/assets/protection-shield.svg",
    altText: "Protection Shield",
    title: "Identity & Financial Protection",
    description: `With $1M identity theft insurance <span style="font-weight: 700;">included FREE</span>, protect and monitor your personal information, or upgrade to the complete family plan with $5M coverage, advanced protection of your identity, finances, credit, antivirus, VPN, for up to 10 adults. <br /> <br /> <span style="font-weight: 700;">Your digital security is our priority</span>`,
  },
  {
    icon: "/assets/sim.svg",
    altText: "Sim",
    title: "Keep Your Number",
    description: `Transfer your existing phone number to VLE Mobile <span style="font-weight: 700;">100% FREE</span>, and with zero interruption to your driving service. Your current plan will remain active with your old provider until the transfer is complete, so there's no downtime at all. <br /> <br /> <span style="font-weight: 700;">Same number, better service</span>`,
  },
  {
    icon: "/assets/unlimited.svg",
    altText: "Unlimited",
    title: "Unlimited Data Carryover",
    description: `Your unused data never expires. Perfect for varying work schedules and busy periods so you never waste what you've paid for. <br /> <br /> <span style="font-weight: 700;">Use what you pay for, when you need it</span>`,
  },
];

export const WhyPlatformDrivers = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-[#F8F0EA] px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12 py-9 sm:py-14 md:py-[5.5rem] lg:py-[7.5rem]">
      <div className="flex flex-col xl:flex-row gap-7 sm:gap-8 md:gap-9 lg:gap-12 xl:gap-16 2xl:gap-[6.69rem] max-w-[86.5625rem] mx-auto">
        <div className="w-full xl:max-w-[38.5625rem] text-center xl:text-left mx-auto xl:mx-0">
          <h2 className="font-mobile text-[#1D1D1B] text-[clamp(1.5rem,calc(2.5vw+1rem),3.125rem)] font-normal leading-snug md:leading-normal lg:leading-[4rem]">
            Why Platform Drivers Choose VLE Mobile
          </h2>
          <p className="text-[#1D1D1B] text-sm sm:text-[0.925rem] md:text-base font-normal leading-5 sm:leading-6 md:leading-7 mt-4 sm:mt-5 lg:mt-7 mb-6 sm:mb-7 lg:mb-9">
            Drive for Uber, Lyft, DoorDash, or other app? You need your phone
            working everywhere for GPS, orders, and talking to customers. VLE
            Mobile is the only carrier with triple 5G network plans made just
            for drivers like you, reliable coverage that works wherever you go.
          </p>
          <Button
            type="button"
            variant="blackBtn"
            className="max-w-[19rem] sm:max-w-[21rem] lg:max-w-[24.6875rem] h-12 sm:h-14 lg:h-[4.25rem] text-white text-sm sm:text-[0.925rem] md:text-base lg:text-lg font-semibold md:leading-[1.575rem] lg:leading-[2.28738rem] hover:shadow-md"
            onClick={() => navigate("/imei-check")}
          >
            Click here for phone compatibility -&gt;
          </Button>
        </div>
        <div className="flex flex-col items-center gap-12 sm:gap-16 lg:gap-20 w-[90%] md:w-full bg-white max-w-[38.875rem] pl-4 pr-6 pt-3 pb-9 sm:pl-6 sm:pr-9 sm:pt-4 sm:pb-12 lg:pl-[1.875rem] lg:pr-[2.69rem] lg:pt-5 lg:pb-[3.75rem] border border-white rounded-[1.05894rem] mx-auto xl:mx-0">
          {platformDrivers.map((driver, index) => (
            <div
              key={index}
              className={`flex gap-3 sm:gap-4 lg:gap-5 ${
                index === 0
                  ? "bg-[#070816] px-11 py-6 sm:pl-[3.25rem] sm:pr-14 sm:py-7 lg:pl-[3.69rem] lg:pr-[3.88rem] lg:py-[2.56rem] rounded-[1.23544rem] -ml-10 -mr-12 sm:-ml-14 sm:-mr-16 md:ml-0 md:-mr-2 md:w-[43.75rem] shadow-[0px_14.119px_98.836px_0px_rgba(212,217,232,0.35)]"
                  : ""
              }`}
            >
              <div
                className={`flex-shrink-0 inline-flex items-center justify-center ${
                  index === 0 ? "bg-white" : "bg-[#070816]"
                } size-10 sm:size-11 lg:size-[3.125rem] rounded-full`}
              >
                <img
                  src={driver.icon}
                  alt={driver.altText}
                  className="size-6 sm:size-7 lg:size-8"
                />
              </div>
              <div className="flex-1">
                <h3
                  className={`font-mobile text-lg sm:text-xl md:text-2xl lg:text-[1.625rem] font-normal leading-5 sm:leading-6 md:leading-7 lg:leading-[2.1rem] mb-1.5 sm:mb-2 lg:mb-2.5 ${
                    index === 0 ? "text-white" : "text-[#070816]"
                  }`}
                >
                  {driver.title}
                </h3>
                <p
                  className={`text-sm sm:text-[0.925rem] lg:text-base font-normal ${
                    index === 0
                      ? "text-white leading-5 sm:leading-[1.3125rem] lg:leading-6"
                      : "text-[#070816] leading-[1.1875rem] sm:leading-5 lg:leading-[1.4rem]"
                  }`}
                  dangerouslySetInnerHTML={{ __html: driver.description }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
